import React, { useEffect } from 'react';
import {
  Form,
  FormInstance,
  SelectBooleanInput
} from '@lightbeamhealth/blueprint-form';
import { Row, Col } from '../../../../grid';
import { CardBlock } from '../../../organisms/card';

interface EpxDischargeHTSettingsData {
  alerts?: boolean;
  alertAfterHour?: boolean;
}

const DefaultSettings: EpxDischargeHTSettingsData = {
  alerts: true,
  alertAfterHour: false
};

interface EpxDischargeHTSettingsProps {
  setForm?: (form: FormInstance<EpxDischargeHTSettingsData>) => void;
  onSubmit?: (data: EpxDischargeHTSettingsData) => void;
  disabled?: boolean;
}

const EpxDischargeHTSettings = ({
  setForm,
  onSubmit: _onSubmit,
  disabled
}: EpxDischargeHTSettingsProps): JSX.Element => {
  const form = new FormInstance<EpxDischargeHTSettingsData>(DefaultSettings);
  useEffect(() => {
    if (setForm) {
      setForm(form);
    }
  }, []);
  const onChange = (data: EpxDischargeHTSettingsData): void => {
    form.setData(data);
  };
  const onSubmit = (data: EpxDischargeHTSettingsData): void => {
    _onSubmit(data);
  };
  return (
    <CardBlock bare>
      <Form form={form} onChange={onChange} onSubmit={onSubmit}>
        <CardBlock>
          <Row>
            <Col sm={12}>
              <SelectBooleanInput
                label="Enable Alerts for Patient"
                name="alerts"
                fill
                disabled={disabled}
              />
            </Col>
            <Col sm={12}>
              <SelectBooleanInput
                label="Inform Business Hour"
                name="alertAfterHour"
                fill
                disabled={disabled}
              />
            </Col>
          </Row>
        </CardBlock>
      </Form>
    </CardBlock>
  );
};

export default EpxDischargeHTSettings;
